





































































































































































































































































































































import {
	AccountTypeEnum, ExportQueryModel,
	PartyExportModel,
	PartyExportTypeEnum,
	PartyModel,
	TenantUserModel,
	WorkTaskEvaluationGroupModel,
	WorkTaskRuleModel
} from '@/libs/Api';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {CrudDataStats} from '@/libs/core/+state/models/crud-data-stats';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {createCrudQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import {CrudQueryPredicate} from '@/libs/core/+state/models/crud-query-predicate';
import EvaluationDialog from '@/libs/parties/components/EvaluationDialog.vue';
import {workTaskEvaluationsGroupsStore} from '@/libs/work-task-evaluation-groups/+state/store';
import Page from '@/Page.vue';
import {Component, Prop, Ref, Watch} from 'vue-property-decorator';
import {authStore} from '@/libs/auth/+store/store';
import {AuthGetter} from '@/libs/auth/models/auth-state';
import {partiesStore} from '@/libs/parties/+state/store';
import moment from 'moment';
import {Constants} from '@/constants';
import {CrudOrderBy} from '@/libs/core/+state/models/crud-order-by';
import {workTaskRulesStore} from '@/libs/work-task-rules/+state/store';
import ExportDialog from "@/libs/common/components-smart/ExportDialog.vue";
import ApiService from "@/libs/core/api-service";
import {b64toBlob} from "@/libs/common/functions/b64toBlob";
import { Filters, PageFilter } from '@/filters';

@Component({
    components: {
        EvaluationDialog
    }
})
export default class ClientsEvaluation extends Page {

    mobileFiltersShow = false;
    filterStart: string | null = "";
    filterEnd: string | null = "";
    filterParty: string | null = "";
    filterTown: string | null = "";
    filterDistrict: string | null = "";
    filterUser: string | null = "";
    evaluationType: string | null = "Planned";
    pagingChanged = false;
    pageIndex = 1;
    pageSize = 25;
    sortBy = [ "nextWorkTaskEvaluationDate" ];
    sortDesc = [ false ];
    pageInitialization = true;
	exporting = false
	selectedParties: PartyModel[] = [];
	selectedEvaluations: WorkTaskEvaluationGroupModel[] = [];

    get headers() {
        if (this.evaluationType == "Planned") {
            return [
                { text: this.$i18n.t("clientsEvaluation.table.headers.client"), value: "lastName", align: "left", width: "20%" },
                { text: this.$i18n.t("clientsEvaluation.table.headers.district"), value: "district.name", align: "left", width: "15%" },
                { text: this.$i18n.t("clientsEvaluation.table.headers.town"), value: "town.name", align: "left", width: "15%" },
                { text: this.$i18n.t("clientsEvaluation.table.headers.address"), value: "address", align: "left", width: "15%", sortable: false },
                { text: this.$i18n.t("clientsEvaluation.table.headers.mainCareProvider"), value: "mainCareProvider.lastName", align: "left", width: "15%" },
                { text: this.$i18n.t("clientsEvaluation.table.headers.phoneNumber"), value: "phoneNumber", align: "left", width: "10%" },
                { text: "Datum hodnocení", value: "nextWorkTaskEvaluationDate", align: "left", width: "10%" },
                { text: "", value: "id", align: "left", width: "15%", sortable: false },
            ];
        }
        else if (this.evaluationType == "Done") {
            return [
                { text: this.$i18n.t("clientsEvaluation.table.headers.client"), value: "party.lastName", align: "left", width: "25%" },
                { text: this.$i18n.t("clientsEvaluation.table.headers.district"), value: "party.district.name", align: "left", width: "15%" },
                { text: this.$i18n.t("clientsEvaluation.table.headers.town"), value: "party.town.name", align: "left", width: "15%" },
                { text: this.$i18n.t("clientsEvaluation.table.headers.address"), value: "party.address", align: "left", width: "15%", sortable: false },
                { text: "Hodnotící pracovník", value: "tenantUser.user.lastName", align: "left", width: "10%" },
                { text: this.$i18n.t("clientsEvaluation.table.headers.phoneNumber"), value: "party.phoneNumber", align: "left", width: "15%" },
                { text: "Datum hodnocení", value: "time", align: "left", width: "10%" },
                { text: "", value: "id", align: "left", width: "15%", sortable: false },
            ];
        } else {
            return [];
        }
    }

    get itemsParties () {
        return [...partiesStore.useGetter(CrudGetter.Data)];
    }

    get totalRowsParties (): number {
        return ({...partiesStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    get itemsEvaluations () {
        return [...workTaskEvaluationsGroupsStore.useGetter(CrudGetter.Data)];
    }

    get totalRowsEvaluations (): number {
        return ({...workTaskEvaluationsGroupsStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    get isAdmin (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Admin;
    }

    get loadingParties(): boolean {
        return partiesStore.useGetter(CrudGetter.Pending);
    }

    get loadingEvaluations(): boolean {
        return partiesStore.useGetter(CrudGetter.Pending);
    }

    get workTaskRules(): WorkTaskRuleModel[] {
        return workTaskRulesStore.useGetter(CrudGetter.Data);
    }

	get isUserFilterReadonly(): boolean {
		const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
		return tenantUser.accountType == AccountTypeEnum.Worker;
	}

    @Prop() tenantId!: string;

    @Ref() evaluationDialog!: EvaluationDialog;
	@Ref() exportDialog!: ExportDialog;

    @Watch("filterStart")
    @Watch("filterEnd")
    @Watch("filterParty")
    @Watch("filterTown")
    @Watch("filterDistrict")
    @Watch("filterUser")
    filtersChanged (v: string, p: string) {
        if (this.pageInitialization || this.isPageLocked())
            return;
		this.selectedParties = [];
		this.selectedEvaluations = [];
        this.saveQuery();
        this.pageLock(this.$nextTick()).then(() => {
            this.pageIndex = 1;
            if (this.evaluationType == "Planned") {
                this.loadPlanned();
            }
            else if (this.evaluationType == "Done") {
                this.loadEvaluated();
            }
        });
    }

    @Watch("pageIndex")
    @Watch("pageSize")
    paginationChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
		this.selectedParties = [];
		this.selectedEvaluations = [];
        this.saveQuery();
        if (this.pagingChanged) {
            this.pagingChanged = false;
            return;
        }
        this.pageLock(this.$nextTick()).then(() => {
            if (this.evaluationType == "Planned") {
                this.loadPlanned();
            }
            else if (this.evaluationType == "Done") {
                this.loadEvaluated();
            }
        });
    }

    @Watch("pageSize")
    pageSizeChanged () {
        if (this.pageInitialization)
            return;
		this.selectedParties = [];
		this.selectedEvaluations = [];
        this.pageIndex = 1;
    }

    @Watch("sortBy")
    @Watch("sortDesc")
    sortChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
		this.selectedParties = [];
		this.selectedEvaluations = [];
        this.saveQuery();
        this.pageLock(this.$nextTick()).then(() => {
            if (this.evaluationType == "Planned") {
                this.loadPlanned();
            }
            else if (this.evaluationType == "Done") {
                this.loadEvaluated();
            }
        });
    }

    @Watch("evaluationType", { immediate: false })
    evaluationTypeChanged (v: string, p: string, e: any) {
        if (this.pagingChanged || this.isPageLocked())
            return;
		this.selectedParties = [];
		this.selectedEvaluations = [];
        if (v == "Planned") {
            this.sortBy = [ "nextWorkTaskEvaluationDate" ];
            this.sortDesc = [ false ];
            this.pageLock(this.$nextTick()).then(() => {
                this.loadPlanned();
            });
        }
        else if (this.evaluationType == "Done") {
            this.sortBy = [ "time" ];
            this.sortDesc = [ true ];
            this.pageLock(this.$nextTick()).then(() => {
                this.loadEvaluated();
            });
        }
    }

    created () {
        if (this.getQuery("party") != null || this.getQuery("district") != null || this.getQuery("town") != null || this.getQuery("user") != null || this.getQuery("pageSize") != null || this.getQuery("type") != null) {
            this.filterStart = moment(this.getQuery("start")).isValid() ? moment(this.getQuery("start")).format("YYYY-MM-DDT00:00:00") : "";
            this.filterEnd = moment(this.getQuery("end")).isValid() ? moment(this.getQuery("end")).format("YYYY-MM-DDT23:59:59") : "";
            this.filterParty = this.getQuery("party") ?? "";
            this.filterDistrict = this.getQuery("district") ?? "";
            this.filterTown = this.getQuery("town") ?? "";
            this.filterUser = this.getQuery("user") ?? "";
            this.evaluationType = this.getQuery("type") ?? "Planned";
            this.pageSize = this.getQueryInt("pageSize") ?? 25;
        }
        else {
            //this.filterStart = moment(window.localStorage.ceStart).isValid() ? moment(window.localStorage.ceStart).format("YYYY-MM-DDT00:00:00") : moment().startOf("month").format("YYYY-MM-DDT00:00:00");
            //this.filterEnd = moment(window.localStorage.ceEnd).isValid() ? moment(window.localStorage.ceEnd).format("YYYY-MM-DDT00:00:00") : moment().endOf("month").format("YYYY-MM-DDT00:00:00");
            this.filterStart = Filters.loadFilter('ClientsEvaluations', 'start') ? moment(Filters.loadFilter('ClientsEvaluations', 'start')).format("YYYY-MM-DDT00:00:00") : null;
            this.filterEnd = Filters.loadFilter('ClientsEvaluations', 'end') ? moment(Filters.loadFilter('ClientsEvaluations', 'end')).format("YYYY-MM-DDT00:00:00") : null;
            this.filterParty = Filters.loadFilter('ClientsEvaluations', 'party') ?? null;
            this.filterDistrict = Filters.loadFilter('ClientsEvaluations', 'district') ?? null;
            this.filterTown = Filters.loadFilter('ClientsEvaluations', 'town') ?? null;
            this.filterUser = Filters.loadFilter('ClientsEvaluations', 'user') ?? null;
            this.evaluationType = Filters.loadFilter('ClientsEvaluations', 'evaluationType') ?? null;
            this.pageSize = Number(Filters.loadFilter('ClientsEvaluations', 'pageSize', '25')) ?? 25;
            this.saveQuery();
        }
        if (this.evaluationType == "Planned") {
            this.sortBy = [ "nextWorkTaskEvaluationDate" ];
            this.sortDesc = [ false ];
        }
        else if (this.evaluationType == "Done") {
            this.sortBy = [ "time" ];
            this.sortDesc = [ true ];
        }
    }

    mounted () {
        if (this.evaluationType == "Planned" || this.isPageLocked()) {
            this.loadPlanned();
        }
        else if (this.evaluationType == "Done") {
            this.loadEvaluated();
        }
		const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
		if (tenantUser.accountType == AccountTypeEnum.Worker) {
			this.filterUser = tenantUser.userId!;
		}
    }

    saveQuery () {
        this.setQuery("start", this.filterStart ? moment(this.filterStart).format("YYYY-MM-DD") : null);
        this.setQuery("end", this.filterEnd ? moment(this.filterEnd).format("YYYY-MM-DD") : null);
        this.setQuery("party", this.filterParty);
        this.setQuery("district", this.filterDistrict);
        this.setQuery("town", this.filterTown);
        this.setQuery("user", this.filterUser);
        this.setQuery("type", this.evaluationType);
        this.setQuery("pageSize", this.pageSize?.toString());
        const filters: PageFilter = {
            pageName: 'ClientsEvaluations',
            filters: [
                { name: 'start', value: this.filterStart },
                { name: 'end', value: this.filterEnd },
                { name: 'party', value: this.filterParty },
                { name: 'district', value: this.filterDistrict },
                { name: 'town', value: this.filterTown },
                { name: 'user', value: this.filterUser },
                { name: 'evaluationType', value: this.evaluationType },
                { name: 'pageSize', value: this.pageSize > 0 ? this.pageSize : 25 }
            ]
        };
        Filters.saveFilters(filters);
    }

    clearFilters () {
        this.filterStart = "";
        this.filterEnd = "";
        this.filterParty = null;
        if (this.isAdmin) {
            this.filterDistrict = null;
        }
        this.filterTown = null;
        this.filterUser = null;
        this.saveQuery();
    }

    getPlannedFilters(): CrudQueryPredicate[] {

        let filters: CrudQueryPredicate[] = [
            { field: "clientStateId", op: "eq", comparand: Constants.PartyStateActiveId }
        ];

        if (this.filterStart)
            filters.push({ field: "nextWorkTaskEvaluationDate", op: "gte", comparand: moment(this.filterStart).format("YYYY-MM-DDT00:00:00") });

        if (this.filterEnd)
            filters.push({ field: "nextWorkTaskEvaluationDate", op: "lte", comparand: moment(this.filterEnd).format("YYYY-MM-DDT23:59:59") });

        if (this.filterParty)
            filters.push({ field: "id", op: "eq", comparand: this.filterParty });

        if (this.filterUser)
            filters.push({ field: "mainCareProviderId", op: "eq", comparand: this.filterUser });

        if (this.filterDistrict)
            filters.push({ field: "districtId", op: "eq", comparand: this.filterDistrict });

        if (this.filterTown)
            filters.push({ field: "townId", op: "eq", comparand: this.filterTown });

		const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
		if (tenantUser.accountType == AccountTypeEnum.Worker) {
			filters.push({ field: "mainCareProviderId", op: "eq", comparand: tenantUser.userId! });
		}

		return filters;

    }

    getEvaluatedFilters(): CrudQueryPredicate[] {

        let filters: CrudQueryPredicate[] = [
            { field: "party.clientStateId", op: "eq", comparand: Constants.PartyStateActiveId }
        ];

        if (this.filterStart)
            filters.push({ field: "time", op: "gte", comparand: moment(this.filterStart).format("YYYY-MM-DDT00:00:00") });

        if (this.filterEnd)
            filters.push({ field: "time", op: "lte", comparand: moment(this.filterEnd).format("YYYY-MM-DDT23:59:59") });

        if (this.filterParty)
            filters.push({ field: "partyId", op: "eq", comparand: this.filterParty });

        if (this.filterUser)
            filters.push({ field: "createdById", op: "eq", comparand: this.filterUser });

        if (this.filterDistrict)
            filters.push({ field: "party.districtId", op: "eq", comparand: this.filterDistrict });

        if (this.filterTown)
            filters.push({ field: "party.townId", op: "eq", comparand: this.filterTown });

		const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
		if (tenantUser.accountType == AccountTypeEnum.Worker) {
			filters.push({ field: "createdById", op: "eq", comparand: tenantUser.userId! });
		}

        return filters;

    }

    loadPlanned () {
        const orderBy: CrudOrderBy<PartyModel>[] = [];
        if (this.sortBy.length == 0) {
            orderBy.push({
                field: "nextWorkTaskEvaluationDate",
                index: 1,
                order: "asc"
            });
        }
        else {
            orderBy.push({
                field: this.sortBy.first(),
                index: 1,
                order: this.sortDesc.first() ? "desc" : "asc"
            });
        }
        partiesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<PartyModel>(orderBy, this.getPlannedFilters(), {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
        }));
        this.subscribe(partiesStore, CrudReponse.GetAll).then(() => {
            this.pageInitialization = false;
        });
    }

    loadEvaluated () {
        const orderBy: CrudOrderBy<PartyModel>[] = [];
        if (this.sortBy.length == 0) {
            orderBy.push({
                field: "time",
                index: 1,
                order: "desc"
            });
        }
        else {
            orderBy.push({
                field: this.sortBy.first(),
                index: 1,
                order: this.sortDesc.first() ? "desc" : "asc"
            });
        }
        workTaskEvaluationsGroupsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskEvaluationGroupModel>(orderBy, this.getEvaluatedFilters(), {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
        }));
        this.subscribe(workTaskEvaluationsGroupsStore, CrudReponse.GetAll).then(() => {
            this.pageInitialization = false;
        });
    }

    showGroupDialogClick (item: WorkTaskEvaluationGroupModel) {
        this.evaluationDialog.open(item.id, item.partyId, null, null);
    }

	exportClick () {
		this.exportDialog.open();
	}

	exportDownload () {
		if (this.evaluationType == "Planned") {
			const filters = this.getPlannedFilters();
			const parties = [...partiesStore.useGetter(CrudGetter.Data)];
			if (this.selectedParties.count() > 0 && this.selectedParties.count() < parties.count()) {
				filters.push({ field: "id", op: "in", comparand: this.selectedParties.select(x => x.id!).toArray() });
			}
			const query = {
				exportType: PartyExportTypeEnum.ClientEvaluations,
				fileName: "",
				predicates: filters,
				orderby: [
					{field: "nextWorkTaskEvaluationDate", index: 1, order: "asc"},
					{field: "lastName", index: 2, order: "asc"},
					{field: "firstName", index: 3, order: "asc"}
				]
			} as PartyExportModel;
			this.exporting = true;
			ApiService.api.exportPartyBatch(1, 99999, query).then((x: any) => {
				const res = x.data;
				const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', res.returnValue.filename!);
				document.body.appendChild(link);
				link.click();
				link.parentNode!.removeChild(link);
				this.exporting = false;
				this.exportDialog.close();
			}).catch((e) => {
				console.error(e);
				this.exporting = false;
			});
		}
		else {
			const filters = this.getEvaluatedFilters();
			const evaluations = [...workTaskEvaluationsGroupsStore.useGetter(CrudGetter.Data)];
			if (this.selectedEvaluations.count() > 0 && this.selectedEvaluations.count() < evaluations.count()) {
				filters.push({ field: "id", op: "in", comparand: this.selectedEvaluations.select(x => x.id!).toArray() });
			}
			const query = {
				fileName: "",
				predicates: filters,
				orderby: [
					{field: "time", index: 1, order: "desc"},
					{field: "party.lastName", index: 2, order: "asc"},
					{field: "party.firstName", index: 3, order: "asc"}
				]
			} as ExportQueryModel;
			this.exporting = true;
			ApiService.api.exportWorkTaskEvaluationGroupBatch(1, 99999, query).then((x: any) => {
				const res = x.data;
				const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', res.returnValue.filename!);
				document.body.appendChild(link);
				link.click();
				link.parentNode!.removeChild(link);
				this.exporting = false;
				this.exportDialog.close();
			}).catch((e) => {
				console.error(e);
				this.exporting = false;
			});
		}
	}

}
